import { render, staticRenderFns } from "./ProjectFormSelect.vue?vue&type=template&id=66ec264e&"
import script from "./ProjectFormSelect.vue?vue&type=script&lang=js&"
export * from "./ProjectFormSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormLabel: require('/workspace/components/Form/FormLabel.vue').default})
